import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import jsPDF from 'jspdf';
import "jspdf-autotable";
import Auth from '../../common/Auth';
import Config from '../../Config';
import { DoReport } from './ReportExport';
import moment from 'moment';
import _ from 'lodash';
import AgentPerformanceReport from '../AgentPerformanceReport';

function AgentPerformancePdf(props) {

    const [rowData, setRowData] = useState(props.rowData);
    const [data, setData] = useState(props.data);

    const auth = new Auth();
    const config = new Config();
    const $http = config.DConnect();

    const colstyle = { fontSize: '30px', display: 'none' };
    const numformat = new Intl.NumberFormat("en-GB", { maximumFractionDigits: 2, minimumFractionDigits: 2 });

    useEffect(() => {

        setData(props.data);
        setRowData(props.rowData);

        getCompany();
    }, [props.data, props.rowData]);

    const getCompany = () => {

        $http.get('admin/wapp/setup').then(res => {
            let company = auth.decryptData(res.data);

            showReport(company);
        })
    }

    const showReport = (company) => {
        const pdf = new jsPDF("p", "mm", "a4", true);

        let props = {
            title: `${data.agent} PERFORMANCE REPORT`,
            subject: `${data.agent} PERFORMANCE REPORT`,
            keywords: 'draw, screen, alpha, lotto',
            creator: 'Mojave Consultancy',
            company: company
        },

            mainTable = {
                html: '#tbMaintable', startY: (55), theme: 'grid', styles: { fontSize: 8, showHead: 'everyPage' }, margin: { left: 5 },
                headStyles: { fillColor: '#efefef', textColor: '#000000', lineColor: '#000000', lineWidth: .1 },
                columnStyles: {
                    0: { cellWidth: 10 },
                    1: { cellWidth: 65 },
                    2: { cellWidth: 35},
                    3: { cellWidth: 35},
                    4: { cellWidth: 25, halign: 'right' },
                    5: { cellWidth: 30, halign: 'right' }
                }
            },

            edata = {
                'Start Date': moment(data.startDate).format('DD MMM, YYYY'),
                'End Date': moment(data.endDate).format('DD MMM, YYYY'),
                'Total Retailers': numformat.format(data.total),
                'Active Retailers': numformat.format(data.active),
                'In-Active Retailers': numformat.format(data.inactive),
                'Total Sales': numformat.format(data.sales)
            },

            pdfdata = DoReport(pdf, props, mainTable, edata);

        document.getElementById('pdfPreview').src = pdfdata;
    }

    const goBack = () => {
        ReactDOM.render(
            <AgentPerformanceReport />,
            document.getElementById('generalReport_inners')
        );
    }

    return (
        <div className="row">
            <div className="col-xs-12 col-sm-10">
                <iframe id="pdfPreview" type="application/pdf" style={{ 'width': '100%', 'height': '80vh', 'border': 'none' }}></iframe>
            </div>
            <div className="col-xs-12 col-sm-2">
                <div className="btn-group btn-group-vertical btn-group-sm">
                    <button className="btn btn-warning" onClick={goBack}>
                        <i className="fa fa-backward"></i> Back
                    </button>
                    <button className="btn btn-success"> <i className="fa fa-file-excel-o"></i> Export Excel</button>
                    <button className="btn btn-success"> <i className="fa fa-file-archive-o"></i> Export CSV</button>
                </div>
            </div>
            <div className="col-xs-12">
                <table id='tbMaintable' style={colstyle}>
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Retailer ID - Name</th>
                            <th>Last Transaction</th>
                            <th>Terminal</th>
                            <th>No. of Bets</th>
                            <th>Amount</th>
                        </tr>
                    </thead>
                    <tbody>
                        {rowData.map(rdata =>
                            <tr>
                                <td>{rdata.id}</td>
                                <td>{rdata.retailer}</td>
                                <td>{rdata.lastran}</td>
                                <td>{rdata.terminal}</td>
                                <td>{rdata.bets}</td>
                                <td>{numformat.format(rdata.amount)}</td>
                            </tr>)}
                        <tr>
                            <th></th>
                            <th>Total</th>
                            <th></th>
                            <th></th>
                            <th>{numformat.format(_.sumBy(rowData, 'bets'))}</th>
                            <th>{numformat.format(_.sumBy(rowData, 'amount'))}</th>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    );
}

export default AgentPerformancePdf;
